import { render } from "./NotificationCard.vue?vue&type=template&id=0f391fae&scoped=true&ts=true&lang=pug"
import script from "./NotificationCard.vue?vue&type=script&lang=ts"
export * from "./NotificationCard.vue?vue&type=script&lang=ts"

import "./NotificationCard.vue?vue&type=style&index=0&id=0f391fae&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Sultan/CMS Admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f391fae"]])

export default __exports__